@if(isLoading){
<div class="loading">
    <div class="loading_txt">
        <div class="load_txt">{{"startorderUk.loadinglabel" | cxTranslate}}</div>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
    </div>
</div>
}
@if(enablePage?.showAmendReviewPage && reviewPageData){
<div class="reviewOrderBody_container" id="OM_reviewOrder">
    <div class="col-xs-6 cart_neworderheader pb-5">Amend Your {{seasonValue | seasonspilt}}
        @if(prepreseason==seasonValue){
        Pre-order
        }
        @else{
        Order
        }
    </div>
    <section class="col-xs-12 OM_productDoseSection">
        <button class="OM_backText" (click)="handleOnBackBtnClick()">
            <img class="OM_backArrow" alt="Previous screen"
                src="../../../assets/images/blackarrow.png">@if(seasonValue==prepreseason){

            Back to Delivery Week Selection
            } @else{
            {{"startorderUk.reviewpage.backtoamenddeliveryweek" |
            cxTranslate}}
            }</button>
        <div class="col-xs-12 OM_selectline"></div>
        <div class="clearboth"></div>
        
        <!-- location details starts -->
        <div class="reviewOrder_locContainer">
            <input type="hidden" name="requestType" value="CR">
            <!-- location 1 starts -->
            <div class="locationDiv">
                @for(location of reviewPageData.reviewData?.cartEntries;track location; let i= $index){
                <div class="locDiv col-xs-12 no-pad" id="prodLocation1">
                    <div id="deliveylocation">
                        <div class="row">
                            <div class="col-xs-12">
                                <div id="deliveryparent">
                                    
                                    <div class="col-xs-12 no-padding" [ngClass]="seasonValue==prepreseason?'prepredelivery':''">


                                        <div class="preprebox no-margin" [ngClass]="seasonValue==prepreseason?'col-xs-8':'col-xs-12'">
                                            <div [innerHtml]="reviewcontent?.content"></div>
                                            <div class="col-xs-12 inputSection prepredelivery">
                                                <div class="inputParent col-xs-8 no-pad">
                                                    <label class="prelabel">{{"startorderUk.reviewpage.firstname" |
                                                        cxTranslate}}</label> <input type="text"
                                                        [ngClass]="location.deliveryContact.firstNameErrorMsg ? 'has-error' : ''"
                                                        name="prepre{{i}}" class="dynFirstname col-xs-6 form-control"
                                                        id="" [(ngModel)]="location.deliveryContact.name"
                                                        (keyup)="checkForErrrors()"
                                                        (ngModelChange)="handleOnInputValueChange($event,'firstName',i)"
                                                        autocomplete="no">
                                                    @if(location.deliveryContact.firstNameErrorMsg){
                                                    <span
                                                        class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span>
                                                    }
                                                    @if(location.deliveryContact.firstNameErrorMsg){
                                                    <label id="prepre{{i}}" class="error help-block"
                                                        for="{{i}}">{{location.deliveryContact.firstNameErrorMsg}}</label>
                                                    }
                                                    <!-- Please enter only letters -->
                                                </div>
                                                <div class="inputParent"
                                                    [ngClass]="location.deliveryContact.emailErrorMsg ? 'has-error' : ''">
                                                    <label class="prelabel">{{"startorderUk.reviewpage.email" |
                                                        cxTranslate}}</label> <input type="text" name="prepre{{i}}"
                                                        [(ngModel)]="location.deliveryContact.email"
                                                        (keyup)="checkForErrrors()"
                                                        (ngModelChange)="handleOnInputValueChange($event,'email',i)"
                                                        class="dynemail form-control" id="" autocomplete="no">
                                                    @if(location.deliveryContact.emailErrorMsg){
                                                    <span
                                                        class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span>
                                                    }
                                                    @if(location.deliveryContact.emailErrorMsg){
                                                    <label id="prepre{{i}}" class="error help-block"
                                                        for="{{i}}">{{location.deliveryContact.emailErrorMsg}}</label>
                                                    }
                                                </div>
                                                <div class="">
                                                    <div class="col-xs-6 no-pad inputParent"
                                                        [ngClass]="location.deliveryContact.phoneNumberErrorMsg ? 'has-error' : ''">
                                                        <label class="prelabel">{{"startorderUk.reviewpage.phnnum" |
                                                            cxTranslate}}</label> <input type="text" name="prepre{{i}}"
                                                            class="dynphno form-control" id=""
                                                            (keyup)="checkForErrrors()"
                                                            [(ngModel)]="location.deliveryContact.phone"
                                                            (ngModelChange)="handleOnInputValueChange($event,'phone',i)"
                                                            maxlength="11" autocomplete="no">
                                                        @if(location.deliveryContact.phoneNumberErrorMsg){
                                                        <span
                                                            class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span>
                                                        }
                                                        @if(location.deliveryContact.phoneNumberErrorMsg){
                                                        <label id="prepre{{i}}" class="error help-block" for="{{i}}">
                                                            {{location.deliveryContact.phoneNumberErrorMsg}}</label>
                                                        }
                                                        <!-- Please enter only Numbers -->
                                                    </div>
                                                    <div class="col-xs-6 no-right-pad inputParent">
                                                        <label
                                                            class="prelabel preext left20">{{"startorderUk.reviewpage.ext"
                                                            | cxTranslate}}</label> <input type="text"
                                                            name="prepre{{i}}" class="dynphnoextn form-control" id=""
                                                            [(ngModel)]="location.deliveryContact.ext" maxlength="4"
                                                            autocomplete="no"
                                                            (ngModelChange)="handleOnInputValueChange($event,'ext',i)">
                                                        @if(location.deliveryContact.phoneextErrorMsg){
                                                        <span
                                                            class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span>
                                                        }
                                                        @if(location.deliveryContact.phoneextErrorMsg){
                                                        <label id="prepre{{i}}" class="error help-block" for="{{i}}">
                                                            {{location.deliveryContact.phoneextErrorMsg}}</label>
                                                        }
                                                    </div>
                                                </div>
                                                <!-- <div class="userInfoHeader">NHS Code</div> -->
                                                <!-- <div class="inputParent col-xs-8 no-pad no-margin-bottom">
                                                    <label class="prelabel">{{"startorderUk.reviewpage.nhscode" |
                                                        cxTranslate}}</label> <input type="text" name="prepre{{i}}"
                                                        class="form-control dynnhsreview" [(ngModel)]="location.nhsCode"
                                                        (ngModelChange)="handleOnInputValueChange($event,'nhs',i)"
                                                        maxlength="6" autocomplete="no" value="">
                                                    @if(location.nhsErrorMsg){
                                                    <span
                                                        class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span>
                                                    }
                                                    @if(location.nhsErrorMsg){
                                                    <label id="prepre{{i}}" class="error help-block" for="{{i}}"
                                                        >{{location.nhsErrorMsg}}</label>
                                                    }
                                                </div> -->
                                            </div>
                                        </div>
                                        <div class="no-padding" [ngClass]="seasonValue==prepreseason?'col-xs-4 ':'col-xs-12 prepredelivery horizontalview'">
                                            <div class="accountbox">
                                                <div class="userInfoHeader">Account Address</div>

                                                <div class="accounttext">{{reviewPageData?.orderSummary?.delLocation}}
                                                </div>


                                            </div>
                                            <div class="accountbox">



                                                <div [innerHtml]="reviewcontent?.LargeText2"></div>
                                                @if(reviewPageData.reviewData.salesContact){
                                                <div class="rightText3 float_left">
                                                    {{reviewPageData.reviewData.salesContact.name}}<br>{{reviewPageData.reviewData.salesContact.email}}<br>{{reviewPageData.reviewData.salesContact.phone}}
                                                    Ext. {{reviewPageData.reviewData.salesContact.ext}}</div>
                                                }

                                                <div class="clearboth"></div>



                                            </div>

                                            @if(seasonValue!=prepreseason){
                                                <div class="accountbox">
                                                    
                                                    
                                                        <div class=" float_left orderbox">
                                                            <div class="rightText4 no-margin">{{"startorderUk.reviewpage.orderterms" | cxTranslate}}</div>
                                            <div class="rightText5">{{"startorderUk.reviewpage.saleorreturn" | cxTranslate}}</div>
                                            <div class="rightText6">
                                                {{"startorderUk.reviewpage.sormessage1" | cxTranslate}}<span>
                                                    @if(reviewPageData.priceResponse.SOR){{{reviewPageData.priceResponse.SOR
                                                        | number}}}
                                                    @else{0}%</span>
                                                    {{"startorderUk.reviewpage.sormessage2" | cxTranslate}}.</div>
                                            <div class="rightText7">Credit days</div>
                                            <div class="rightText8">
                                                {{"startorderUk.reviewpage.creditmessage1" | cxTranslate}}<span>
                                                    {{reviewPageData.priceResponse.creditDays}}</span>
                                                    {{"startorderUk.reviewpage.creditmessage2" | cxTranslate}}.</div>
                                                        </div>
                                                        <input type="hidden" id="business-org_type" value="GP Medical Practice">
                            
                                                    
                            
                                                </div>
                                                }
                                        </div>



                                    </div>
                                    
                                    @if(seasonValue==prepreseason){
                                    <div class="prepredelivery col-xs-12  preprebox">

                                        <div class="col-xs-7 no-padding">
                                            <div class="col-xs-12 no-padding licencetext margin-B20"
                                                [innerHtml]="reviewcontent?.LargeText1"></div>
                                            <div class="inputParent col-xs-6 no-padding-right"
                                                [ngClass]="location.licenseInfo.nameErrorMsg ? 'has-error' : ''">
                                                <label class="prelabel left20">{{"startorderUk.reviewpage.licensename" |
                                                    cxTranslate}}</label> <input type="text" name="{{i}}"
                                                    class="col-xs-6 form-control liname" id=""
                                                    (keyup)="checkForErrrors()" [(ngModel)]="location.licenseInfo.name"
                                                    (ngModelChange)="handleOnInputValueChange($event,'licenseInfoName',i)"
                                                    autocomplete="no">
                                                @if(location.licenseInfo.nameErrorMsg){
                                                <span
                                                    class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span>
                                                }
                                                @if(location.licenseInfo.nameErrorMsg){
                                                <label id="{{i}}" class="error help-block" for="{{i}}">
                                                    {{location.licenseInfo.nameErrorMsg}}</label>
                                                }
                                                <!-- Please enter only letters -->
                                            </div>
                                            <div class="inputParent col-xs-6 positionrel "
                                                [ngClass]="location.licenseInfo.numberErrorMsg ? 'has-error' : ''">
                                                <label class="prelabel left20">{{"startorderUk.reviewpage.licensenum" |
                                                    cxTranslate}}</label><input type="text" name="{{i}}"
                                                    class="form-control lino" id=""
                                                    [(ngModel)]="location.licenseInfo.number"
                                                    (keyup)="checkForErrrors()"
                                                    (ngModelChange)="handleOnInputValueChange($event,'licenseInfoNumber',i)"
                                                    maxlength="15" autocomplete="no">
                                                @if(location.licenseInfo.numberErrorMsg){
                                                <span
                                                    class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span>
                                                }
                                                @if(location.licenseInfo.numberErrorMsg){
                                                <label id="{{i}}" class="error help-block" for="{{i}}">
                                                    {{location.licenseInfo.numberErrorMsg}}</label>
                                                }
                                            </div>
                                            <div class="licence_checkboxparent col-xs-12">
                                                <label class="checkbox-button inputParent" id="license_check"> <input
                                                        type="checkbox" name="checkbox[0]"
                                                        (change)="handlepreprebookvalidation($event)"
                                                        [(ngModel)]="location.licenseInfo.checked"
                                                        (ngModelChange)="handleOnInputValueChange($event,'checkbox',i)"
                                                        class="review_checkbox licenceCheckbox" id=""> <span
                                                        class="checkbox-button_control"></span> <label
                                                        class="checkboxtext">{{"startorderUk.reviewpage.licenseconfirmmsg"
                                                        | cxTranslate}}</label>

                                                </label>
                                                @if(location.licenseInfo.checkboxErrorMsg){
                                                <label id="checkbox[1]-error" class="error help-block"
                                                    for="checkbox[1]">{{location.licenseInfo.checkboxErrorMsg}}</label>
                                                }
                                            </div>
                                        </div>
                                        <div class="col-xs-5 no-padding">
                                            <div class="userInfoHeader ">
                                                {{"startorderUk.reviewpage.ponumberfull" | cxTranslate}}</div>
                                                <div class="userInfoDetails pomargin">Please enter your purchase order number, if required.</div>

                                            <div class="inputParent col-xs-12 no-pad no-margin-bottom">
                                                <label class="prelabel">{{"startorderUk.reviewpage.ponumber" |
                                                    cxTranslate}}</label> <input type="text" name="{{i}}"
                                                    class="form-control" id="" value="" maxlength="10" autocomplete="no"
                                                    [(ngModel)]="location.poNumber">
                                            </div>
                                        </div>
                                    </div>
                                }@else{
                                    <div class="prepredelivery col-xs-12  preprebox">

                                        <div class="col-xs-12 no-padding">
                                            <div class="col-xs-12 no-padding licencetext margin-B20"
                                                [innerHtml]="reviewcontent?.LargeText1"></div>
                                            <div class="inputParent col-xs-6 no-padding-right"
                                                [ngClass]="location.licenseInfo.nameErrorMsg ? 'has-error' : ''">
                                                <label class="prelabel left20">{{"startorderUk.reviewpage.licensename" |
                                                    cxTranslate}}</label> <input type="text" name="{{i}}"
                                                    class="col-xs-6 form-control liname" id=""
                                                    (keyup)="checkForErrrors()" [(ngModel)]="location.licenseInfo.name"
                                                    (ngModelChange)="handleOnInputValueChange($event,'licenseInfoName',i)"
                                                    autocomplete="no">
                                                @if(location.licenseInfo.nameErrorMsg){
                                                <span
                                                    class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span>
                                                }
                                                @if(location.licenseInfo.nameErrorMsg){
                                                <label id="{{i}}" class="error help-block" for="{{i}}">
                                                    {{location.licenseInfo.nameErrorMsg}}</label>
                                                }
                                                <!-- Please enter only letters -->
                                            </div>
                                            <div class="inputParent col-xs-6 positionrel "
                                                [ngClass]="location.licenseInfo.numberErrorMsg ? 'has-error' : ''">
                                                <label class="prelabel left20">{{"startorderUk.reviewpage.licensenum" |
                                                    cxTranslate}}</label><input type="text" name="{{i}}"
                                                    class="form-control lino" id=""
                                                    [(ngModel)]="location.licenseInfo.number"
                                                    (keyup)="checkForErrrors()"
                                                    (ngModelChange)="handleOnInputValueChange($event,'licenseInfoNumber',i)"
                                                    maxlength="15" autocomplete="no">
                                                @if(location.licenseInfo.numberErrorMsg){
                                                <span
                                                    class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span>
                                                }
                                                @if(location.licenseInfo.numberErrorMsg){
                                                <label id="{{i}}" class="error help-block" for="{{i}}">
                                                    {{location.licenseInfo.numberErrorMsg}}</label>
                                                }
                                            </div>
                                            <div class="licence_checkboxparent col-xs-12">
                                                <label class="checkbox-button inputParent" id="license_check"> <input
                                                        type="checkbox" name="checkbox[0]"
                                                        (change)="handlepreprebookvalidation($event)"
                                                        [(ngModel)]="location.licenseInfo.checked"
                                                        (ngModelChange)="handleOnInputValueChange($event,'checkbox',i)"
                                                        class="review_checkbox licenceCheckbox" id=""> <span
                                                        class="checkbox-button_control"></span> <label
                                                        class="checkboxtext">{{"startorderUk.reviewpage.licenseconfirmmsg"
                                                        | cxTranslate}}</label>

                                                </label>
                                                @if(location.licenseInfo.checkboxErrorMsg){
                                                <label id="checkbox[1]-error" class="error help-block"
                                                    for="checkbox[1]">{{location.licenseInfo.checkboxErrorMsg}}</label>
                                                }
                                            </div>
                                        </div>
                                       
                                    </div>
                                    <div class="prepredelivery col-xs-12  preprebox">
                                        <div class="col-xs-12 no-padding">
                                            <div class="userInfoHeader">
                                                {{"startorderUk.reviewpage.ponumberfull" | cxTranslate}}</div>
                                                <div class="userInfoDetails margin-B20">Please enter your purchase order number, if required.</div>

                                            <div class="inputParent col-xs-12 no-pad no-margin-bottom">
                                                <label class="prelabel">{{"startorderUk.reviewpage.ponumber" |
                                                    cxTranslate}}</label> <input type="text" name="{{i}}"
                                                    class="form-control" id="" value="" maxlength="10" autocomplete="no"
                                                    [(ngModel)]="location.poNumber">
                                            </div>
                                        </div>
                                    </div>
                                }
                                    
                                    <form #weekselectionform="ngForm">

                                        <div class="deliveylocation col-xs-12 no-padding">
                                            <div class="greyline"></div>
                                           <!--  <div class="row">
                                                @if(seasonValue!=prepreseason){
                                                <div class="col-xs-1 locationNumber">
                                                    {{reviewPageData?.orderSummary?.delLocation}}
                                                </div>
                                                }
                                            </div> -->
                                            <div [ngClass]="seasonValue==prepreseason?'prepreboxdelivery':'border_box'">
                                                <div class="row amendreview_Header_Row">
                                                    @if(seasonValue==preseason){
                                                    <div class="prodTableHeader">
                                                       
                                                        <span>Products</span>
                                                        

                                                    </div><!-- HARDCORED -->
                                                }
                                                    @if(seasonValue==inseason){
                                               
                                                   
                                                        <div class="col-xs-1 deliverycol locationtext margin-B30">
                                                            Location</div>
                                                        <div class="col-xs-1 deliverycol1 dashsymbol">|</div>
                                                        <div class="col-xs-11 deliverycol2 locationdetail margin-B30">
                                                            <span>{{location.locname}}</span>
                                                        </div>
                                                        } 
                                                    

                                                </div>
                                                <div class="row margin-B20">
                                                    <div class="seasonvalue">{{amendreviewdelivery}} Delivery Dates</div>
                                                    <div class="no-padding deliveyweek">(week commencing)</div>
                                                    <!-- HARDCORED -->

                                                </div>
                                             
                                                
                                                <div class="row">
                                                    <div class="col-xs-12 no-padding">

                                                        <table class="deliverytable">
                                                            @for( prodData of location.products;track prodData; let p=
                                                            $index){

                                                            @if((prodData.baseName=='AQIV' || prodData.baseName=='Aujemflu' )&& prodData.qty !== 0){
                                                                <tr>
                                                                    @if(reviewPageData.productList[0].baseProductName=='aTIV - 10 Pack'){
                                                                        <td class="productheader" colspan="13">
                                                                          
                                                                            {{"startorderUk.deliveryweek.ativ" | cxTranslate}}
                                                                          
                                                                            <span> (aIIV)</span>
                                                                            <div class="middletext"><span
                                                                                class="tenpack">{{"startorderUk.deliveryweek.10packlabel"
                                                                                | cxTranslate}}</span>
                                                                            <br><span class="prepreyear">(50+ years)</span></div>
                                                                            
                                                                        </td>
                                                                        }
                                                                        @else{
                                                                            <td class="productheader" colspan="13">
                                                                            Aujemflu (aIIVc) <span class="tenitem"> {{"startorderUk.deliveryweek.10packlabel"
                                                                                | cxTranslate}}</span>
                                                                                <div class="middletext middletextnew"><div class="listprice">{{reviewcontent?.solutiontype}}</div>
                                                                               
                                                                                <div class="priceDetail">Customer Price &#163;<span>{{reviewPageData?.productList[0]?.priceData?.value
                                                                                    | number:'1.2' }}</span>  (ex VAT)</div></div>
                                                                            </td>
                                                                        }
            
                                                              
                                                                </tr>
                                                            <tr id="month">
                                                                
                                                                @for(deliverydate of deliverySlotArray;track
                                                                deliverydate;let d=$index){
                                                                @if(d!= maxDeliverySlots){
                                                                <td class=" datetext">{{deliverydate.month}}
                                                                </td>
                                                                }
                                                                @if(d == maxDeliverySlots){

                                                                <td class="gapbet"></td>
                                                                <td class=" datetext">{{deliverydate.month}}
                                                                </td>
                                                                }

                                                                }

                                                                <td class="gapdose"></td>
                                                                <td class=" dosestext">Doses</td>
                                                                

                                                            </tr>
                                                            <tr class="">
                                                                
                                                                @for(deliverydate of deliverySlotArray;track
                                                                deliverydate;let d=$index){
                                                                @if(d!=maxDeliverySlots){
                                                                <td class=" datetext">{{deliverydate.date}}</td>
                                                                }
                                                                @if(d== maxDeliverySlots){
                                                                <td class="gapbet"></td>
                                                                <td class=" datetext">{{deliverydate.date}}</td>
                                                                }

                                                                }


                                                                <td class="gapdose"></td>
                                                                <td class=" dosestext">
                                                                    {{"startorderUk.deliveryweek.ordered" |
                                                                    cxTranslate}}</td>
                                                                

                                                            </tr>
                                   
                                                            <tr id="delivey_aQIV">

                                                              
                           


                                                                

                                                                @for(productinput1 of
                                                                prodData.deliverySlots;track productinput1; let
                                                                j=$index){
                                                                @if(j!=maxDeliverySlots){
                                                                <td class="deliverydate_input">
                                                                    <input type="text"  [ngClass]="prodData.deliverySlots[j].available=='N'?'at_capacity':''"
                                                                    [disabled]="prodData.deliverySlots[j].available=='N' || prodData.deliverySlots[j].disablerule==true"
                                                                        value="{{prodData.deliverySlots[j].quantity == 0 ? null : prodData.deliverySlots[j].quantity | number}}"
                                                                        autocomplete="off"
                                                                        class="delivery_data  aqivcount form-control dynvacinedoses"
                                                                        id="aqivfirst[{{i}}][{{j}}]" readonly
                                                                        name="createOrderData[{{i}}].createOrderProductData[0].createOrderDeliverySlotData[{{j}}]].quantity" />
                                                                </td>
                                                                }
                                                                @else{
                                                                <td class="gapbet"></td>
                                                                <td class="deliverydate_input">
                                                                    <input type="text" autocomplete="off" [ngClass]="prodData.deliverySlots[j].available=='N'?'at_capacity':''"
                                                                    [disabled]="prodData.deliverySlots[j].available=='N' || prodData.deliverySlots[j].disablerule==true"
                                                                        value="{{prodData.deliverySlots[j].quantity == 0 ? null : prodData.deliverySlots[j].quantity | number}}"
                                                                        class="delivery_data  aqivcount form-control dynvacinedoses"
                                                                        id="aqivfirst[{{i}}][{{j}}]" readonly
                                                                        name="createOrderData[{{i}}].createOrderProductData[0].createOrderDeliverySlotData[{{j}}]].quantity" />
                                                                </td>
                                                                }

                                                                }

                                                                <td class="gapdose"></td>
                                                                <td class="deliveryallocated_input dosesbox">
                                                                    <input type="text" autocomplete="off"
                                                                        value="{{prodData.qty | number}}"
                                                                        class=" delivery_data aqiv_allocated form-control dynallacted"
                                                                        id="aqivallocated[{{i}}]"
                                                                        name="deliveryweek.aqivallocated[{{i}}]"
                                                                        readonly value="" />
                                                                   
                                                                </td>
                                                                <!--<td class="greentick">
                                                                            </td> -->
                                                            </tr>
                                                            <tr>
                                                                <td></td>
                                                                
                                                                <td [attr.colspan]="prodData.deliverySlots.length" class="rightfloat"> @if(seasonValue!=prepreseason){
                                                                    <div class="totaldose">
                                                                        Total (ex VAT)
                                                                    </div>}</td>
                                                                <td >


                                                                    @if(seasonValue!=prepreseason){
                                                                        <input autocomplete="off"
                                                                        class=" delivery_data aqivtotal form-control " name="deliveryweek.aqivtotalcost"
                                                                        id="aqivtotalcost" [value]="prodData.qty *
                                                                            reviewPageData?.productList[0]?.priceData?.value | currency:'GBP':'symbol':'1.2-2'
                                                                            " 
                                                                        readonly />
                                                                       
                                                                            }

                                                                </td>
                                                            </tr>

                                                            }
                                                            @if(prodData.baseName=='QIVC' && prodData.qty !== 0){
                                                                <tr>
                                                                    @if(reviewPageData.productList[1].baseProductName=='TIVc - 10 Pack'){
                                                                        <td class="productheader" colspan="13">
                                                                            {{"startorderUk.deliveryweek.tivc" | cxTranslate}}
                                                                            <span> (IIVc)</span>@if(seasonValue==prepreseason){
                                                                                <span class="tenitem"> {{"startorderUk.deliveryweek.10packlabel"
                                                                                    | cxTranslate}}</span>
                                                                                    <div class="middletext">
                                                                                        <span class="tenpack float_left">
                                                                                            <span
                                                                                                class="float_left">{{"startorderUk.deliveryweek.10packlabel"
                                                                                                | cxTranslate}} </span>
                                                                                            <br>
                                                                                            <span
                                                                                                class="prepreyear">{{"startorderUk.deliveryweek.18to64yearslabel"
                                                                                                | cxTranslate}}
                                                                                            </span>
                                                                                        </span>
                                                                                    </div>
                                                                            }@else{
                                                                                <span class="tenitem"> {{"startorderUk.deliveryweek.10packlabel"
                                                                                    | cxTranslate}}</span>
                                                                                <div class="middletext  middletextnew"><div class="listprice">{{reviewcontent?.headline}}</div>        
                                                                                   
                                                                                <div class="priceDetail">Customer Price &#163;<span>{{reviewPageData?.productList[1]?.priceData?.value
                                                                                    | number:'1.2' }}</span>  (ex VAT)</div></div>
                                                                            }
                                                                           
                                                                        </td>
                                   
                                                                            }
                                                                         
                                                                            
                
                
                                                                           
                
                
                
                
                
                                                                </tr> 
                                                                <tr id="month">
                                                                   
                                                                    @for(deliverydate of deliverySlotArray;track
                                                                    deliverydate;let d=$index){
                                                                    @if(d!= maxDeliverySlots){
                                                                    <td class=" datetext">{{deliverydate.month}}
                                                                    </td>
                                                                    }
                                                                    @if(d == maxDeliverySlots){
    
                                                                    <td class="gapbet"></td>
                                                                    <td class=" datetext">{{deliverydate.month}}
                                                                    </td>
                                                                    }
    
                                                                    }
    
                                                                    <td class="gapdose"></td>
                                                                    <td class=" dosestext">Doses</td>
                                                                   
    
                                                                </tr>
                                                                <tr class="">
                                                                   
                                                                    @for(deliverydate of deliverySlotArray;track
                                                                    deliverydate;let d=$index){
                                                                    @if(d!=maxDeliverySlots){
                                                                    <td class=" datetext">{{deliverydate.date}}</td>
                                                                    }
                                                                    @if(d== maxDeliverySlots){
                                                                    <td class="gapbet"></td>
                                                                    <td class=" datetext">{{deliverydate.date}}</td>
                                                                    }
    
                                                                    }
    
    
                                                                    <td class="gapdose"></td>
                                                                    <td class=" dosestext">
                                                                        {{"startorderUk.deliveryweek.ordered" |
                                                                        cxTranslate}}</td>
                                                                    
    
                                                                </tr>
                                                            <tr id="delivey_QIVc">
                                                               

                                                               <!--  <td class="deliverycol1"></td> -->
                                                               @for( productinput2 of prodData.deliverySlots; track productinput2;let j=$index){
                                                                    @if(j!=maxDeliverySlots){
                                                                        <td class="deliverydate_input">
                                                                            <input type="text" autocomplete="off" [ngClass]="prodData.deliverySlots[j].available=='N'?'at_capacity':''"
                                                                            [disabled]="prodData.deliverySlots[j].available=='N' || prodData.deliverySlots[j].disablerule==true"
                                                                                value="{{prodData.deliverySlots[j].quantity == 0 ? null : prodData.deliverySlots[j].quantity | number}}"
                                                                                class="delivery_data qivccount  form-control dynvacinedoses"
                                                                                id="qivcfirst[{{i}}][{{j}}]" readonly
                                                                                name="createOrderData[{{i}}].createOrderProductData[1].createOrderDeliverySlotData[{{j}}].quantity" />
                                                                        </td>
                                                                    }
                                                                    @else{
                                                                        <td class="gapbet"></td>
                                                                        <td class="deliverydate_input">
                                                                            <input type="text" autocomplete="off" [ngClass]="prodData.deliverySlots[j].available=='N'?'at_capacity':''"
                                                                            [disabled]="prodData.deliverySlots[j].available=='N' || prodData.deliverySlots[j].disablerule==true"
                                                                                value="{{prodData.deliverySlots[j].quantity == 0 ? null : prodData.deliverySlots[j].quantity | number}}"
                                                                                class="delivery_data qivccount form-control dynvacinedoses"
                                                                                id="qivcfirst[{{i}}][{{j}}]" readonly
                                                                                name="createOrderData[{{i}}].createOrderProductData[1].createOrderDeliverySlotData[{{j}}].quantity" />
                                                                        </td>
                                                                    }

                                                            }

                                                                <td class="gapdose"></td>
                                                                <td class="deliveryallocated_input dosesbox">
                                                                    <input type="text" autocomplete="off"
                                                                        value="{{prodData.qty | number}}"
                                                                        class="  delivery_data qivcallocated form-control dynallacted"
                                                                        id="qivcallocated[{{i}}]"
                                                                        name="deliveryweek.qivcallocated[{{i}}]"
                                                                        readonly />
                                                                       
                                                                </td>
                                                                <!--<td class="deliverydate_input dosesbox "><input type="number" 
                                                                                autocomplete="off" class=" delivery_data qivctotal form-control"
                                                                                id="qivctotal[{{i}}]" value={{product.deliverySlots[j].quantity}} readonly /></td>
                                                                        <td class="greentick" >
                                                                        </td> -->
                                                            </tr>
                                                            
                                                            <tr class="qivcyear">
                                                               
                                                                <td  >
                                                                </td>
                                                                 <td [attr.colspan]="prodData.deliverySlots.length" class="rightfloat">


                                                                    @if(seasonValue!=prepreseason){
                                                                        <div class="totaldose">
                                                                            Total (ex VAT)
                                                                        </div>
                                                                    }
                                                                        </td>
                                                                        <td>
                                                                            @if(seasonValue!=prepreseason){
                                                                        <input autocomplete="off"
                                                                        class=" delivery_data aqivtotal form-control " name="deliveryweek.aqivtotalcost"
                                                                        id="aqivtotalcost" [value]="prodData.qty *
                                                                            reviewPageData?.productList[1]?.priceData?.value | currency:'GBP':'symbol':'1.2-2'
                                                                            " 
                                                                        readonly />
                                                                       
                                                                            }

                                                                </td>
                                                            </tr>


                                                            }


                                                            }
                                                            <tr class="margin-T20">

                                                                <td ></td>
                                                                <td colspan="12" class="rightfloat totaldose">@if(seasonValue!=prepreseason){Total Cost (ex VAT)}</td>
                                                               
                                                                <td class=""> @if(seasonValue!=prepreseason){
                                                                    <input autocomplete="off"
                                                                    class=" delivery_data aqivtotal form-control totalreviewcost" name="deliveryweek.aqivtotalcost"
                                                                    id="aqivtotalcost" [value]="'£' + (location.prodCost)"
                                                                    readonly />
                                                                    
                                                                }
                                                            </td>
                                                                
                                                            </tr>
                                                            @if(seasonValue==prepreseason){
                                                                <tr>
                                                            <td colspan="13" class="pricetext">{{reviewcontent?.text3}}
                                                            </td>
                                                           </tr>
                                                            }




                                                        </table>




                                                    </div>


                                                </div>
                                            </div>
                                        </div>


                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- User info starts -->
                   <!--  @if(seasonValue!=prepreseason){
                    <div class="userInfoContainer">
                        <div class="col-xs-4 no-pad col1 salebox">
                            <div class="border_box float_left">
                                <div [innerHtml]="reviewcontent?.LargeText2"></div>
                                @if(reviewPageData.reviewData.salesContact){
                                <div class="rightText3 float_left">
                                    {{reviewPageData.reviewData.salesContact.name}}<br>{{reviewPageData.reviewData.salesContact.email}}<br>{{reviewPageData.reviewData.salesContact.phone}}
                                    Ext. {{reviewPageData.reviewData.salesContact.ext}}</div>
                                }

                            </div>
                            <div class="clearboth"></div>
                            <div class="border_box float_left orderbox">
                                <div class="rightText4">{{"startorderUk.reviewpage.orderterms" | cxTranslate}}</div>
                                <div class="rightText5">{{"startorderUk.reviewpage.saleorreturn" | cxTranslate}}</div>

                                <div class="rightText6">
                                    {{"startorderUk.reviewpage.sormessage1" | cxTranslate}}<span>

                                        @if(reviewPageData.priceResponse.SOR){{{reviewPageData.priceResponse.SOR
                                            | number}}}
                                        @else{0}%</span>
                                    {{"startorderUk.reviewpage.sormessage2" | cxTranslate}}</div>
                                <div class="rightText7">{{"startorderUk.creditdays" | cxTranslate}}</div>
                                <div class="rightText8">
                                    {{"startorderUk.reviewpage.creditmessage1" | cxTranslate}}<span>
                                        {{reviewPageData.priceResponse.creditDays}}</span>
                                    {{"startorderUk.reviewpage.creditmessage2" | cxTranslate}}</div>
                            </div>
                           

                           
                           
                            <input type="hidden" id="business-org_type" value="GP Medical Practice">

                        </div>

                        <div class="col-xs-8 box_2colparent no-pad">
                            <div class="col-xs-6 border_box col2">
                                <div [innerHtml]="reviewcontent?.content"></div>
                                <div class="col-xs-12 inputSection">
                                    <div class="inputParent col-xs-8 no-pad">
                                        <label>{{"startorderUk.reviewpage.firstname" | cxTranslate}}</label> <input
                                            type="text"
                                            [ngClass]="location.deliveryContact.firstNameErrorMsg ? 'has-error' : ''"
                                            name="{{i}}" class="dynFirstname col-xs-6 form-control" id=""
                                            (keyup)="checkForErrrors()" [(ngModel)]="location.deliveryContact.name"
                                            (ngModelChange)="handleOnInputValueChange($event,'firstName',i)"
                                            autocomplete="no">
                                            @if(location.deliveryContact.firstNameErrorMsg){
                                        <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"
                                            ></span>
                                        <label id="{{i}}" class="error help-block" for="{{i}}"
                                           >{{location.deliveryContact.firstNameErrorMsg}}</label>
                                            }
                                        
                                    </div>
                                    <div class="inputParent positionrel"
                                        [ngClass]="location.deliveryContact.emailErrorMsg ? 'has-error' : ''">
                                        <label>{{"startorderUk.reviewpage.email" | cxTranslate}}</label> <input
                                            type="text" name="{{i}}" [(ngModel)]="location.deliveryContact.email"
                                            (keyup)="checkForErrrors()"
                                            (ngModelChange)="handleOnInputValueChange($event,'email',i)"
                                            class="dynemail form-control" id="" autocomplete="no">
                                            @if(location.deliveryContact.emailErrorMsg){
                                        <span 
                                            class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span>
                                        <label id="{{i}}" class="error help-block" for="{{i}}"
                                            >{{location.deliveryContact.emailErrorMsg}}</label>}
                                    </div>
                                    <div class="">
                                        <div class="col-xs-8 no-pad inputParent"
                                            [ngClass]="location.deliveryContact.phoneNumberErrorMsg ? 'has-error' : ''">
                                            <label>{{"startorderUk.reviewpage.phnnum" | cxTranslate}}</label> <input
                                                type="text" name="{{i}}" class="dynphno form-control" id=""
                                                (keyup)="checkForErrrors()" [(ngModel)]="location.deliveryContact.phone"
                                                (ngModelChange)="handleOnInputValueChange($event,'phone',i)"
                                                maxlength="11" autocomplete="no">
                                                @if(location.deliveryContact.phoneNumberErrorMsg){
                                            <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"
                                             ></span>
                                                
                                            <label id="{{i}}" class="error help-block" for="{{i}}"
                                               >
                                                {{location.deliveryContact.phoneNumberErrorMsg}}</label>
                                                }
                                            
                                        </div>
                                        <div class="col-xs-4 no-right-pad inputParent">
                                            <label>{{"startorderUk.reviewpage.ext" | cxTranslate}}</label> <input
                                                type="text" name="{{i}}" class="dynphnoextn form-control" id=""
                                                [(ngModel)]="location.deliveryContact.ext" maxlength="4"
                                                autocomplete="no"
                                                (ngModelChange)="handleOnInputValueChange($event,'ext',i)">
                                                @if(location.deliveryContact.phoneextErrorMsg){
                                            <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span>
                                            <label id="{{i}}" class="error help-block" for="{{i}}">
                                                {{location.deliveryContact.phoneextErrorMsg}}</label>
                                                }
                                        </div>
                                    </div>
                                    
                                    <div class="inputParent col-xs-8 no-pad">
                                        <label>{{"startorderUk.reviewpage.nhscode" | cxTranslate}}</label> <input
                                            type="text" name="{{i}}" class="form-control dynnhsreview"
                                            [(ngModel)]="location.nhsCode"
                                            (ngModelChange)="handleOnInputValueChange($event,'nhs',i)" maxlength="6"
                                            autocomplete="no" value="">
                                            @if(location.nhsErrorMsg){
                                        <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span>
                                        <label id="{{i}}" class="error help-block" for="{{i}}">{{location.nhsErrorMsg}}</label>
                                            }
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-6 no-padding-left">
                                <div class="border_box">
                                    <div class="userInfoHeader">{{"startorderUk.reviewpage.ponumberfull" | cxTranslate}}
                                    </div>
                                    <div class="inputParent col-xs-8 no-pad no-margin-bottom">
                                        <label>{{"startorderUk.reviewpage.ponumber" | cxTranslate}}</label> <input
                                            type="text" name="{{i}}" class="form-control" id="" maxlength="10"
                                            autocomplete="no" [(ngModel)]="location.poNumber">
                                    </div>
                                    <div class="clearboth"></div>
                                </div>
                                <div class="border_box float_left">
                                    <div [innerHtml]="reviewcontent?.LargeText1"></div>
                                    <div class="col-xs-12 inputSection">
                                        <div class="inputParent col-xs-9 no-pad"
                                            [ngClass]="location.licenseInfo.nameErrorMsg ? 'has-error' : ''">
                                            <label>{{"startorderUk.reviewpage.licensename" | cxTranslate}}</label>
                                            <input type="text" name="{{i}}" class="col-xs-6 form-control liname" id=""
                                                (keyup)="checkForErrrors()" [(ngModel)]="location.licenseInfo.name"
                                                (ngModelChange)="handleOnInputValueChange($event,'licenseInfoName',i)"
                                                autocomplete="no">
                                                @if(location.licenseInfo.nameErrorMsg){
                                            <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"
                                               ></span>
                                            <label id="{{i}}" class="error help-block" for="{{i}}">
                                                {{location.licenseInfo.nameErrorMsg}}</label>
                                                }
                                          
                                        </div>
                                        <div class="inputParent positionrel"
                                            [ngClass]="location.licenseInfo.numberErrorMsg ? 'has-error' : ''">
                                            <label>{{"startorderUk.reviewpage.licensenum" | cxTranslate}}</label> <input
                                                type="text" name="{{i}}" class="form-control lino" id=""
                                                [(ngModel)]="location.licenseInfo.number" (keyup)="checkForErrrors()"
                                                (ngModelChange)="handleOnInputValueChange($event,'licenseInfoNumber',i)"
                                                maxlength="15" autocomplete="no">
                                                @if(location.licenseInfo.numberErrorMsg){
                                            <span 
                                                class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span>
                                            <label id="{{i}}" class="error help-block" for="{{i}}"
                                               >
                                                {{location.licenseInfo.numberErrorMsg}}</label>
                                                }
                                        </div>
                                        <div class="licence_checkboxparent">
                                            <label class="checkbox-button inputParent" id="license_check"> <input
                                                    type="checkbox" name="checkbox[0]" (change)="checkForErrrors()"
                                                    [(ngModel)]="location.licenseInfo.checked"
                                                    (ngModelChange)="handleOnInputValueChange($event,'checkbox',i)"
                                                    class="review_checkbox licenceCheckbox" id=""> <span
                                                    class="checkbox-button_control"></span> <label
                                                    class="checkboxtext">{{"startorderUk.reviewpage.licenseconfirmmsg" |
                                                    cxTranslate}}</label>
                                            </label>
                                            @if(location.licenseInfo.checkboxErrorMsg){
                                            <label id="checkbox[1]-error" class="error help-block" for="checkbox[1]"
                                            >{{location.licenseInfo.checkboxErrorMsg}}</label>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    } -->
                </div>
                }
                <input type="hidden" name="createOrderData[1].sorNumber" value="">
                <input type="hidden" name="createOrderData[1].creditDays" value="120">
                <input type="hidden" name="createOrderData[1].locID" value="60149134">
            </div>
            <div>
                <input type="hidden" name="CSRFToken" value="e21a9d3d-fa32-4dd8-bd3a-3b3731da1b6c">
            </div>
        </div>
        <div class="clearboth"></div>
        <!-- confirm order section starts -->
         @if(seasonValue!=prepreseason){
      <!--   <div class=" col-md-12 finaltotal ">Grand Total: £{{totalCost}}</div> -->
        <div class="bottomBG">
            <div class="col-xs-12 OM_tableBottomBtn">
                <div class="col-xs-12 col-md-12 no-padding">
                    <div class="bootom_headerText">Confirm your order to secure your delivery slot for the&nbsp;<span
                        class="reviewseasontxt">{{seasonValue | seasonspilt}}</span>&nbsp;season</div>

                    <div class="main_checkboxparent col-md-12">
                        <label class="checkbox-button"> <input type="checkbox" name="" [(ngModel)]="isChecked"
                                (click)="handleOnCommonCheckboxvalueChange($event)" class="review_checkbox mainCheck"
                                id="">
                            <span class="checkbox-button_control"></span>
                        </label> <label class="mainCheckText">{{"startorderUk.byconfirm" | cxTranslate}} <a
                                href="/termsOfSale" target="_blank" class="showPopupclick"><b>{{"startorderUk.term" |
                                    cxTranslate}}</b></a>,
                            {{"startorderUk.confirmordertxt2" | cxTranslate}}
                            {{amendreviewdelivery}}&nbsp;{{"startorderUk.confirmordertxt3" | cxTranslate}}</label>
                    </div>
                </div>
                
            </div>


            <!-- register checkbox -->
            <div class="col-xs-12 col-md-12 materialcheckbox">

                <div class="main_checkboxparent col-md-12 no-padding">
                    <label class="checkbox-button"> <input type="checkbox" name="" [(ngModel)]="materialcheck"
                            class="review_checkbox mainCheck materialcheck" id="">
                        <span class="checkbox-button_control"></span>
                    </label> <label class="mainCheckText">{{reviewcontent?.h2content}}
                    </label>
                </div>
            </div>
            <div class="col-xs-12 col-md-12 OM_confirmBtnParent">
                <button class="OM_confirmOrderBtn prvntDoubleClick" [disabled]="!isChecked || !isAllFieldsValid"
                    (click)="handleOnOrderClick('confirmOrder')">Confirm Order</button>
            </div>

            @if(reviewPageData.orderSummary.status != 'Amendment Confirmed' && reviewPageData.orderSummary.status != 'Order Confirmed' && seasonValue == preseason){
            <div class="col-xs-12 OM_selectline"
                >
            </div>
        }
            <div class="clearboth"></div>
            <!-- save order section -->
             @if(!reviewPageData?.saveOrderClosed){
            <div class="saveParent" >
                <div class="saveOrderSection">
                    <div class="col-xs-12 col-md-10 saveText">{{"startorderUk.reviewpage.saveordermsg" | cxTranslate}}
                    </div>
                    <button class="OM_saveOrderBtn prvntDoubleClick pl-0 pr-0" [disabled]="!isAllFieldsValid"
                        (click)="handleOnOrderClick('OrderPending')">{{"startorderUk.reviewpage.saveamendorder" |
                        cxTranslate}}</button>
                </div>
            </div>
        }
            <div class="col-xs-12 astericText confirmrisk">
                <div class="astericTextpara1">{{"startorderUk.reviewpage.riskfreetxt" | cxTranslate}}</div>
                <div class="astericTextpara2">{{reviewcontent?.paragraphcontent}}</div>
            </div>

        </div>
    }
    @if(seasonValue==prepreseason){
        <!-- prepreseason -->
        <div  class="col-xs-12">
            <div class="confirmbox col-xs-12">

                @if(isAsAgent){
                    <div class="confirmtext">Confirming the amended pre-order delivery slot for the {{prepreseason |
                        seasonspilt}} flu season</div>

                    <button class="prepreconfimrbtn" [disabled]="!isAllFieldsValid"
                        (click)="handleOnOrderClick('OrderPending')">Confirm Amended Order</button>

                    }
              @else{
                    <div class="confirmtext">Confirm your delivery slot for your pre-order to secure your {{prepreseason
                        | seasonspilt}} season</div>

                    <div class="col-xs-12 col-md-12 prepreseaoncheck">
                        <div class="main_checkboxparent col-md-11 no-padding">
                            <label class="checkbox-button"> <input type="checkbox" name="" [(ngModel)]="materialcheck"
                                    class="review_checkbox mainCheck materialcheck" id="">
                                <span class="checkbox-button_control"></span>
                            </label> <label class="mainCheckText">{{reviewcontent?.h2content}}
                            </label>
                        </div>


                    </div>
                    <button class="prepreconfimrbtn" [disabled]="!isAllFieldsValid"
                        (click)="handleOnOrderClick('confirmOrder')">Confirm Amend Order</button>
                    <div class="col-xs-12 astericText" [innerHtml]="reviewcontent?.LargeText3"></div>
              }

            </div>
        </div>
    }

        <!-- provisional order -->
        <div class="clearboth"></div>
        <!-- <div class="provisionalbottomBG">
            <div class="col-xs-12 OM_tableBottomBtn protablebottom">
                <div class="col-xs-12 col-md-8">
                    <div class="bootom_headerText no-margin-bottom">Save your <span
                            class="reviewseasontxt">2024/25</span> provisional order</div>
                    <div class="col-md-10 no-padding margin-T10 ProvisionalReviewSubtext">
                        Once the&nbsp;2024/25&nbsp;flu season ordering opens in August 2024, a final order will be
                        emailed to you outlining full commercial terms</div>
                </div>
                <div class="col-xs-12 col-md-4 saveOrderSection provisionalsection">
                    <button class="OM_saveOrderBtn provisionalsave prvntDoubleClick" disabled="">Save Provisional
                        Order</button>
                </div>
            </div>

        </div> -->

        <!-- In Season Order Changes -->
        <!-- <div class="InseasonbottomBG" style="display: block;">
            <div class="col-xs-12 OM_tableBottomBtn protablebottom">
                <div class="col-xs-12 col-md-8">
                    <div class="bootom_headerText">Confirm your order to secure your&nbsp;<span
                            class="reviewseasontxt">2024/25</span>&nbsp;season order</div>
                    <div class="main_checkboxparent col-md-10">
                        <label class="checkbox-button"> <input type="checkbox" name="" value=""
                                class="review_checkbox mainCheck" id="">
                            <span class="checkbox-button_control"></span>
                        </label> <label class="mainCheckText">By confirming my order I agree to the <a
                                href="/termsOfSale" target="_blank" class="showPopupclick">Terms of Sale</a> including
                                {{reviewPageData.priceResponse.SOR}} SOR </label>
                    </div>
                </div>
                <div class="col-xs-12 col-md-4 inseasonsection pr-0">
                    <button class="inseasonbtn prvntDoubleClick" disabled="">Confirm Order</button>
                </div>
            </div>
        </div> -->
        <!--  Closed -->

    </section>
</div>
}